import React from 'react';
import { Target, Eye, Award, CheckCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';

const About = () => {
  const features = [
    "ISO 9001:2015 Certified Quality Management",
    "PAN India Presence with Multiple Offices",
    "Experienced & Professional Team",
    "Customized Solutions for Every Client",
    "24/7 Support & Service",
    "Compliance with All Labor Laws"
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              About World Winner Management Services
            </h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div>
              <p className="text-gray-600 text-lg leading-relaxed mb-6">
                {companyInfo.description}
              </p>

              {/* Features Grid */}
              <div className="grid grid-cols-1 gap-3 mt-8">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <CheckCircle className="text-blue-600 flex-shrink-0 mt-1" size={20} />
                    <span className="text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Content - Vision & Mission Cards */}
            <div className="space-y-6">
              {/* Vision Card */}
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 shadow-md hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="bg-blue-600 p-3 rounded-lg">
                    <Eye className="text-white" size={24} />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">Our Vision</h3>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  {companyInfo.vision}
                </p>
              </div>

              {/* Mission Card */}
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 shadow-md hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center space-x-4 mb-4">
                  <div className="bg-blue-600 p-3 rounded-lg">
                    <Target className="text-white" size={24} />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">Our Mission</h3>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  {companyInfo.mission}
                </p>
              </div>

              {/* Certification Badge */}
              <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl p-6 shadow-md">
                <div className="flex items-center space-x-4">
                  <div className="bg-amber-600 p-3 rounded-lg">
                    <Award className="text-white" size={24} />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">ISO 9001:2015</h4>
                    <p className="text-sm text-gray-600">Quality Management Certified</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;